/** App bar height for report studio routes — must match ReportStudioLayout toolbar. */
export const REPORT_STUDIO_HEADER_PX = 64;

/** Explicit pixel height for DevExpress (default is 700px if omitted). */
export function reportStudioSurfaceHeight() {
    return `calc(100vh - ${REPORT_STUDIO_HEADER_PX}px)`;
}
